import { render } from "./Atividade.vue?vue&type=template&id=d90c5404"
import script from "./Atividade.vue?vue&type=script&lang=js"
export * from "./Atividade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__